import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {
  ActionOrigin,
  AnalyticsMetadataForContext,
  COMMON_ANALYTICS_ACTIONS,
} from 'constants/AnalyticsConstants';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import useOnMount from 'ui-library/hooks/useOnMount';
import Modal from 'ui-library/modals/Modal';

/** @package */
export const RELEASE_VALUE = 'Embedding Analysis Outputs in Notebook Entries';

export interface SendToEntryBetaModalProps {
  onRequestSubmit: () => void;
  onRequestClose: () => void;
}

export function SendToEntryBetaModal(props: SendToEntryBetaModalProps): JSX.Element {
  const analyticsMetadata: AnalyticsMetadataForContext = {
    actionOrigin: ActionOrigin.ANALYSIS_TOOL,
    modalType: 'create_analysis',
  };
  const analyticsModule = ANALYTICS_MODULE.ANALYSIS_TOOL;

  useOnMount(() => {
    Analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, analyticsModule, analyticsMetadata);
  });

  return (
    <Modal
      title="Request beta access"
      onRequestSubmit={() => {
        Analytics.trackEventWithModule(
          COMMON_ANALYTICS_ACTIONS.SUBMITTED_MODAL,
          analyticsModule,
          analyticsMetadata
        );
        Analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.SUBMITTED_BETA_REQUEST, analyticsModule, {
          ...analyticsMetadata,
          release: RELEASE_VALUE,
        });
        props.onRequestSubmit();
      }}
      onRequestClose={props.onRequestClose}
      buttons={[
        {
          submit: true,
          text: 'Send Request',
          style: ButtonStyle.PRIMARY,
        },
      ]}
    >
      <p className={css(styles.text)}>Click "Send Request" to send a message to our Customer team.</p>
      <p className={css(styles.text)}>
        Look for an e-mail with more detailed information on this beta in the next 24 hours. Just read it and
        reply to complete the sign-up process!
      </p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  text: {
    ...FONT_PROXIMA_13,
  },
});
